module.exports = __webpack_public_path__ + "static/media/icon-message-circle.ebbe6d9a.svg";